import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import {
  Input,
  Label,
  Form,
  FormGroup,
  Col,
  Row,
  FormFeedback
} from 'reactstrap';

import {
  PageWrapper,
  PanelWrapper,
  PanelTopWrapper,
  TitlePage,
  SaveOrCancel,
  Switch,
  PhoneContent,
  AlertMessage
} from 'components';

import {
  InputValidation,
  PostStoreService,
  MessageRequest,
  GetUniqueStore,
  UpdateStoreService
} from 'services';

import * as yup from 'yup';

export const StoresDetail = () => {

  let { topicId } = useParams();

  const populateObject = (invalid, message) => {
    return ({
      invalid,
      message
    })
  }
  const URL_NEW_REGISTER = "new";
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);
  const [televendas, setTelevendas] = useState(false);
  const [placeholder, setPlaceholder] = useState();
  const [label, setLabel] = useState('Endereço');
  const [disabled, setDisabled] = useState();
  const [uf, setUF] = useState('RS');
  const [storeName, setStoreName] = useState(populateObject(false, ''));
  const [addressOrPhrase, setAddressOrPhrase] = useState(populateObject(false, ''));
  const [city, setCity] = useState(populateObject(false, ''));
  const [enable, setEnable] = useState();
  const [link, setLink] = useState();
  const [totalClicks, setTotalClicks] = useState();
  const [monthClicks, setMonthClicks] = useState();

  const storeSchema = yup.object().shape({
    city: yup.string().required(),
    address: yup.string().required(),
    storeName: yup.string().required(),
  });

  const televendaSchema = yup.object().shape({
    phrase: yup.string().required(),
    storeName: yup.string().required()
  });

  const addressFormData = {
    storeName: storeName.value,
    address: addressOrPhrase.value,
    city: city.value
  }

  const televendaFormData = {
    storeName: storeName.value,
    phrase: addressOrPhrase.value
  }

  const getPopulateObject = (input, value) => {

    const inputs = {
      storeName: () => {
        setStoreName(populateObject(true, value))
      },
      address: () => {
        setAddressOrPhrase(populateObject(true, value))
      },
      city: () => {
        setCity(populateObject(true, value))
      },
      phrase: () => {
        setAddressOrPhrase(populateObject(true, value))
      }
    }

    return inputs[input] ? inputs[input]() : chooseAction()
  }

  const startEdit = (response) => {
    const status = response?.status ?? 500;
    if (status === 200) window.location.href = `#lojas/${response.data}`;
  }

  const chooseAction = () => {
    !isEdition() ? PostStoreService(dataStore).then((response) => {
      startEdit(response);
      MessageRequest("Loja cadastrada", response, setMessage, setActive);
    }) : UpdateStoreService(dataStore, topicId).then((response) => {
      MessageRequest("Loja editada", response, setMessage, setActive);
    })
  }

  const toggle = (value) => {
    setActive(value);
  }

  const getValidation = async () => {

    const feedback = await Promise.resolve(
      InputValidation(
        {
          schema: disabled ? televendaSchema : storeSchema,
          formdata: disabled ? televendaFormData : addressFormData
        })
    ).then(value => value);

    if(feedback?.id) {
      return feedback.id.forEach((element, index) => {
        getPopulateObject(element, feedback.error[index] );
      });
    }

    return getPopulateObject(feedback?.id);

  }

  const isEdition = () => {
    return topicId !== URL_NEW_REGISTER;
  }

  useEffect(() => {
    if (isEdition()) {
      GetUniqueStore(topicId).then((value) => {
        setStoreName({ value: value?.name });
        setUF(value?.state);
        setAddressOrPhrase({ value: value?.address });
        setCity({ value: value?.city });
        setTelevendas(value?.teleSales);
        isTeleVendas({ enable: value?.teleSales })
        setEnable(value?.enabled);
        setLink(value?.linkFormatted);
        setTotalClicks(value?.totalInteractionsByStore);
        setMonthClicks(value?.totalInteractionsByStoreInMonth);
      });
    } else {
      isTeleVendas({ enable: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicId]);

  const isTeleVendas = (status) => {
    const action = {
      true: () => {
        setPlaceholder('Ex: Entre em contato com o nosso televendas');
        setLabel('Frase do Tele Vendas *');
        setDisabled(true);
        setCity({ value: '' });
      },
      false: () => {
        setPlaceholder('Ex: Avenida Brasil, 123, Centro');
        setLabel('Endereço *');
        setDisabled(false);
      }
    }

    return action[status.enable] ? action[status.enable]() : void (0);
  }

  const selectUF = (event) => {
    setUF(event.target.value);
  }

  const dataStore = {
    idBrand: localStorage.getItem("@brand"),
    name: storeName.value,
    state: uf,
    city: city.value,
    enabled: enable,
    address: addressOrPhrase.value,
    teleSales: disabled,
    teleSalesDescription: addressOrPhrase.value,
    contacts: null
  }

  const toggleActiveStore = (result) => {
    setEnable(result.enable);
  }

  const renderActive = () => {
    if (isEdition()) {
      return (
        <Col md={3}>
          <FormGroup>
            <Label for="ativo"> Ativo </Label>
            <Switch id={"ativo"} active={enable} status={toggleActiveStore} />
          </FormGroup>
        </Col>
      );
    }
  }

  const renderExtraContent = (label, content, md) => {

    if (isEdition()) {
      return (
        <Col md={md}>
          <FormGroup>
            <Label> {label}</Label>
            <p> {content} </p>
          </FormGroup>
        </Col>
      )
    }
  }

  return (
    <PageWrapper>
      <PanelTopWrapper padding={"py-4"}>
        <TitlePage title={'Lojas'} />
      </PanelTopWrapper>
      <PanelWrapper>
        <Form>
          <Row>
            {renderExtraContent("Link da Loja", link, 6)}
            {renderExtraContent("Cliques no mês", monthClicks, 3)}
            {renderExtraContent("Total de cliques", totalClicks, 3)}
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="nomeLoja"> Nome da Loja * </Label>
                <Input
                  invalid={storeName.invalid}
                  value={storeName.value}
                  id="nomeLoja"
                  placeholder={'Ex: ZZ Brasil Shopping'}
                  onChange={(e) => setStoreName({ value: e.target.value })} />
                <FormFeedback> {storeName.message} </FormFeedback>
              </FormGroup>
            </Col>

            {renderActive()}

            <Col md={3}>
              <FormGroup>
                <Label for="televendas"> Tele Vendas </Label>
                <Switch id={"televendas"} active={televendas} status={isTeleVendas} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="endereco">{label}</Label>
                <Input
                  invalid={addressOrPhrase.invalid}
                  value={addressOrPhrase.value}
                  id="endereco"
                  placeholder={placeholder}
                  onChange={(e) => setAddressOrPhrase({ value: e.target.value })} />
                <FormFeedback> {addressOrPhrase.message} </FormFeedback>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="selectEstado">Estado</Label>
                <Input type="select" value={uf} name="select" id="selectEstado" disabled={disabled} onChange={selectUF}>
                  <option>AC</option>
                  <option>AL</option>
                  <option>AP</option>
                  <option>AM</option>
                  <option>BA</option>
                  <option>CE</option>
                  <option>DF</option>
                  <option>ES</option>
                  <option>GO</option>
                  <option>MA</option>
                  <option>MT</option>
                  <option>MS</option>
                  <option>MG</option>
                  <option>PA</option>
                  <option>PB</option>
                  <option>PR</option>
                  <option>PE</option>
                  <option>PI</option>
                  <option>RJ</option>
                  <option>RN</option>
                  <option>RS</option>
                  <option>RO</option>
                  <option>RR</option>
                  <option>SC</option>
                  <option>SP</option>
                  <option>SE</option>
                  <option>TO</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="cidade">Cidade *</Label>
                <Input invalid={city.invalid} id="cidade" value={city.value} placeholder={'Ex: Novo Hamburgo'} disabled={disabled} onChange={(e) => setCity({ value: e.target.value })} />
                <FormFeedback> {city.message} </FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        </Form>
        <SaveOrCancel
          actionCancel={'lojas'}
          actionSave={getValidation} />
      </PanelWrapper>
      <PhoneContent idStore={topicId} />
      <AlertMessage message={message} active={active} toggle={toggle} />
    </PageWrapper >
  );
};
